<template>
  <div
    v-if="!canInteract || isBooting"
    class="row justify-center items-center absolute-full z-top"
  >
    <q-spinner-puff
      color="accent"
      size="50px"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LoadingIndicator',
  computed: {
    ...mapState('application', ['canInteract', 'isBooting']),
  },
};
</script>
